import React from 'react';
import Resultat from '../Models/Resultat';
import H from '../Utilities/H-BostedValg';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import { VeilederVgsUtenUrAppState } from '../Store';
import { connect } from 'react-redux';
import { toggleFordeling } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ResultatGu } from '../Ids';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface HResultatOwnProps {
    verdiD: string | undefined;
    resultat: Resultat;
    eventId: string | null;
}

type HResultatProps = HResultatOwnProps & MapStateToProps & MapDispatchToProps & {};

class HResultatComponent extends React.PureComponent<HResultatProps> {
    constructor(props: HResultatProps) {
        super(props);
        this.onStipendOgLanClick = this.onStipendOgLanClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }
    
    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleFordeling();
    }

    borBorte = (verdiH: string | undefined): boolean => {
        return verdiH === H.h2_borte;
    };

    onStipendOgLanClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleFordeling();
    }

    render(): JSX.Element {
        const { resultat, verdiD: verdiH, visFordeling, epiContext, eventId } = this.props;

        const { locale } = this.props.epiContext;

        const undertittelStipend: keyof VeilederVgsUrDto = this.borBorte(verdiH)
            ? 'undertittelStipendBorte'
            : 'undertittelStipendHjemme';

        return (
            <div id={ResultatGu} className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--pinegreen">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h4 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'tittelStipend')}
                        </h4>
                    </div>
                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__underresultat-tekst">
                            <span>{tilPengerFormat(resultat.stipend, locale)}</span>
                            <span className="c-veileder__tekst--postfix">&nbsp;{epiContext.valuta}</span>
                        </div>
                        <p className="c-veileder__tekst">{contentResolver(epiContext, undertittelStipend)}</p>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h4 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'tittelLan')}
                        </h4>
                    </div>

                    <div className="c-veileder__content c-veileder__content--with-space-desktop c-veileder__content--indented ">
                        <div className="c-veileder__underresultat-tekst">
                            <span>{tilPengerFormat(resultat.lan, locale)}</span>
                            <span className="c-veileder__tekst--postfix">&nbsp;{epiContext.valuta}</span>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--bunnlenke">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onStipendOgLanClick}>
                            {contentResolver(epiContext, 'lenketekstStipendOgLan')}
                        </button>
                        <ModalCompontent
                            isOpen={visFordeling}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'modalStipendOgLanAriaLabel')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalStipendOgLanTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'modalStipendOgLanContent', 2)}
                            />
                        </ModalCompontent>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederVgsUrDto>;
    visFordeling: boolean;
}

interface MapDispatchToProps {
    toggleFordeling: typeof toggleFordeling;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederVgsUtenUrAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visFordeling: state.valg.visFordeling,
        };
    },
    { toggleFordeling, updateZIndex },
)(HResultatComponent);
